export const getApiBaseUrl = () => {
  if (typeof window !== 'undefined') {
    if (window.__API_BASE_URL__) {
      return window.__API_BASE_URL__;
    }
    const stored = window.localStorage.getItem('apiBaseUrl');
    if (stored) {
      return stored;
    }
  }

  return process.env.REACT_APP_API_URL || '';
};

